import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";

import { useI18next } from "../../../../plugins/gatsby-plugin-ap-i18next/src/useI18next";
import useUser from "../hooks/use-user";
import { config } from "../../../config";

import { 
    form, 
    formField, 
    formFieldLabel, 
    formFieldInput, 
    btnPrimary 
} from "./auth-forms.module.scss";

const { min, repeat } = config.messages.password;
const { required } = config.messages.form;

const initialValues = {
    currentPassword: "",
    newPassword: "",
    repeatPassword: "",
};

const changePass = Yup.object({
    currentPassword: Yup.string(),
    newPassword: Yup.string().min(8, min),
    repeatPassword: Yup.string()
        .required(required)
        .oneOf([Yup.ref("newPassword")], repeat),
});

const PassChangeForm = () => {
    const { t } = useI18next();
    const { passChange } = useUser();

    return (
        <Formik
            initialValues={{ ...initialValues }}
            validationSchema={changePass}
            onSubmit={passChange}
        >
            {(formik) => (
                <form className={form} onSubmit={formik.handleSubmit}>
                    <label className={formField}>
                        <span className={formFieldLabel}>Obecne hasło</span>
                        <input
                            type="password"
                            className={formFieldInput}
                            name="currentPassword"
                            value={formik.values.currentPassword}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            autoComplete="current-password"
                        />
                    </label>

                    <label className={formField}>
                        <span className={formFieldLabel}>Nowe hasło</span>
                        <input
                            type="password"
                            className={formFieldInput}
                            name="newPassword"
                            value={formik.values.newPassword}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            autoComplete="new-password"
                        />
                    </label>

                    <label className={formField}>
                        <span className={formFieldLabel}>Powtórz nowe hasło</span>
                        <input
                            type="password"
                            className={formFieldInput}
                            name="repeatPassword"
                            value={formik.values.repeatPassword}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            autoComplete="new-password"
                        />
                    </label>

                    <button className={btnPrimary} type="submit">
                        Zapisz hasło
                    </button>
                </form>
            )}
        </Formik>
    );
};

export default PassChangeForm;
